import { Outlet } from "react-router-dom";

import { useState } from "react";
import bgImage from "../../assets/images/jewelries.png";
import Header from "../generalLayout/components/Header";
import BasicLayout from "./components/BasicLayout";

const AuthLayout = () => {
  const [showCartModal, setShowCartModal] = useState(false);

  return (
    <BasicLayout is4Auth image={bgImage}>
      <Header setShowCartModal={setShowCartModal} />
      <Outlet />
    </BasicLayout>
  );
};

export default AuthLayout;
